import React, { useEffect } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Grid,
  Tooltip,
  Button,
  TextField
} from '@material-ui/core';
import { AutomationOptions } from 'components/Template';
import InfoIcon from '@material-ui/icons/Info';
import { CloseIcon } from 'components';

const useStyles = makeStyles(theme => ({
  root: {},
  cardActions: {
    flexDirection: 'row-reverse'
  },
  inputGrid: {
    maxWidth: '40rem'
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between'
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    width: '95%'
  }
}));

const Details = props => {
  const {
    className,
    staticContext,
    template,
    next,
    showNav,
    isPopupDialog,
    ...rest
  } = props;
  const {
    isLoading,
    goNext,
    thisTemplate,
    isQueryReadOnly,
    closeQuery,
    handleChange,
    onFocus,
    onBlur,
    getErrorMessage,
    shouldShowError,
    updateCurrentErrorValidationSegment
  } = template;

  useEffect(() => {
    updateCurrentErrorValidationSegment('details');
  }, [thisTemplate, updateCurrentErrorValidationSegment]);

  const classes = useStyles();

  const areInitialSettingsDisabled = () =>
    isTemplateSaved() ||
    thisTemplate.conditionExpression?.subConditionExpressions?.length > 0;

  const isTemplateSaved = () =>
    thisTemplate.uuid && thisTemplate.uuid.length > 0;

  return (
    <div className={classes.root}>
      <Card {...rest} className={clsx(classes.root, className)}>
        <form autoComplete="off">
          {!isPopupDialog && (
            <div className={classes.headerContainer}>
              <div className={classes.title}>
                <CardHeader
                  subheader="* indicates a required field"
                  title="Condition Query Details"
                  titleTypographyProps={{ variant: 'h1' }}
                />
                {isQueryReadOnly() && (
                  <Tooltip
                    title={
                      "You do not have access to edit this query. Tenant Default queries can be edited only with 'ALL' property."
                    }>
                    <InfoIcon size="small" style={{ marginTop: '26px' }} />
                  </Tooltip>
                )}
              </div>
              <CloseIcon onClickClose={closeQuery} />
            </div>
          )}
          <Divider />
          <CardContent>
            <Grid container spacing={3}>
              <Grid item md={6} xs={12}>
                <Grid item xs={12} className={classes.inputGrid}>
                  <TextField
                    fullWidth
                    label="Condition Query Name"
                    margin="dense"
                    name="name"
                    onChange={handleChange}
                    required
                    disabled={isQueryReadOnly()}
                    value={thisTemplate.name || ''}
                    variant="outlined"
                    onFocus={onFocus}
                    onBlur={onBlur}
                    error={shouldShowError('name')}
                    helperText={getErrorMessage('name')}
                  />
                </Grid>

                <AutomationOptions
                  isPopupDialog={isPopupDialog}
                  template={template}
                  type="conditionQueryTemplate"
                  disabled={areInitialSettingsDisabled()}
                />
              </Grid>
            </Grid>
          </CardContent>
          {(next || showNav) && (
            <>
              <Divider />
              <CardActions className={classes.cardActions}>
                <Button
                  color="primary"
                  variant="contained"
                  disabled={isLoading}
                  link={next}
                  onClick={goNext}>
                  Next
                </Button>
              </CardActions>
            </>
          )}
        </form>
      </Card>
    </div>
  );
};

export default Details;
